import { render, staticRenderFns } from "./AgentServiceLanguagePanel.vue?vue&type=template&id=67f581cf&scoped=true"
import script from "./AgentServiceLanguagePanel.vue?vue&type=script&lang=js"
export * from "./AgentServiceLanguagePanel.vue?vue&type=script&lang=js"
import style0 from "./AgentServiceLanguagePanel.vue?vue&type=style&index=0&id=67f581cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f581cf",
  null
  
)

export default component.exports